import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FilterPipe } from 'src/app/pipes/filter.pipe';
import { LogifitModalAccountWisselenComponent } from 'src/app/components/logifit-modal-account-wisselen/logifit-modal-account-wisselen.component';
import { LogifitModalConfirmComponent } from 'src/app/components/logifit-modal-confirm/logifit-modal-confirm.component';
import { LogifitCachedProfilesListComponent } from 'src/app/components/logifit-cached-profiles-list/logifit-cached-profiles-list.component';
import { LogifitMenuRowComponent } from 'src/app/components/logifit-menu-row/logifit-menu-row.component';

@NgModule({
    declarations: [FilterPipe, LogifitModalAccountWisselenComponent, LogifitModalConfirmComponent],
    imports: [CommonModule, IonicModule, LogifitCachedProfilesListComponent, LogifitMenuRowComponent],
    exports: [FilterPipe, LogifitModalAccountWisselenComponent, LogifitModalConfirmComponent, LogifitCachedProfilesListComponent, LogifitMenuRowComponent]
})
export class SharedModule { }